<template>
    <div class="md-layout md-gutter">
        <md-card>
            <md-card-header class="md-card-header-icon md-card-header-blue">
                <div class="card-icon">
                    <font-awesome-icon class="md-icon" :icon="['fa', 'folder']"/>
                </div>
                <h4 class="title">Signatures de l'intervention</h4>
            </md-card-header>
            <md-card-content>
                <div class="md-layout" v-if="signature">
                    <div class="md-layout-item">
                        <div>Technicien GMD :</div>
                        <div class="font-bold">{{ technician.first_name + ' ' + technician.last_name }}</div>
                        <img :src="signaturePath" alt="signatures" class="w-72">
                    </div>
                    <div class="md-layout-item">
                        <div>Signature représentant client :</div>
                        <div v-if="contact">{{ contact.first_name + ' ' +contact.last_name }}</div>
                        <div v-else-if="signature.otherSignatory !== 'null'">{{ signature.otherSignatory }}</div>
                        <div v-if="signature.noSignatory">
                            <span v-if="(parseInt(signature.noSignatory)) === 0"></span>
                            <span v-else-if="parseInt(signature.noSignatory) === 2">Coronavirus : absence de signature du client pour respecter les consignes sanitaires (gestes barrières) du Gouvernement Français.</span>
                            <span v-else-if="(parseInt(signature.noSignatory)) === 1">Pas de signataire</span>
                        </div>
                        <img v-if="signature.signature && (parseInt(signature.noSignatory)) === 0" :src="signature.signature" class="w-72" alt="">
                    </div>
                </div>
            </md-card-content>
        </md-card>
        <md-card>
            <md-card-header class="md-card-header-icon md-card-header-blue">
                <div class="card-icon">
                    <font-awesome-icon class="md-icon" :icon="['fa', 'folder']"/>
                </div>
                <h4 class="title">Changer les informations</h4>
            </md-card-header>
            <md-card-content>
                <div class="md-layout" v-if="newSignature">
                    <div class="intervention-details__card mt-2 md-layout-item md-size-50">
                        <div class="pt-1" v-if="newSignature.noSignatory !== '1'">
                            <div class="md-multiselect">
                                <label>Signataire</label>
                                <multiselect v-model="newSignatory"
                                             :options="contacts"
                                             :disabled="newSignature.noSignatory === '1' || isOtherSignatory"
                                             :show-labels="false"
                                             group-values="contacts"
                                             group-label="type"
                                             placeholder="Contact"
                                             label="full_name"
                                             track-by="id">
                                    <template slot="noOptions">La liste est vide</template>
                                    <template slot="noResult">Aucun élement correspondant</template>
                                </multiselect>
                            </div>
                            <md-checkbox v-model="isOtherSignatory" :value="true" class="mb-1 mt-1">Autre signataire</md-checkbox>
                            <md-field class="md-invalid mb-2.5 mt-3.5" v-if="isOtherSignatory">
                                <label>Signataire</label>
                                <md-input v-model="newSignature.otherSignatory" type="text" />
                                <validation-error :errors="apiValidationErrors.otherSignatory" />
                            </md-field>
                        </div>
                        <div class="pt-1">
                            <md-radio v-model="newSignature.noSignatory" :value="'0'" class="my-1 mt-0">Signataire présent</md-radio>
                            <md-radio v-model="newSignature.noSignatory" :value="'1'" class="my-1">Pas de signataire</md-radio>
                            <md-radio v-model="newSignature.noSignatory" :value="'2'" class="my-1">Absence de signature (Covid-19)</md-radio>
                        </div>
	                    <md-field class="md-invalid">
		                    <label>Message personnalisé</label>
		                    <md-textarea md-autogrow v-model="newSignature.comment"></md-textarea>
	                    </md-field>
                        <div class="mb-1.5 flex items-center justify-between">
                            <md-button class="md-success md-icon-button md-raised my-0" :disabled="awaitingRequest" @click="updateSignatureData">
                                <font-awesome-icon class="md-icon" :icon="['fa', 'check-circle']" />
                                <span class="leading-none font-medium ml-2">Valider</span>
                            </md-button>
                        </div>
                    </div>
                </div>
            </md-card-content>
        </md-card>
    </div>
</template>

<script>

import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";

export default {
    name: "Signature",
    components: { ValidationError },
    mixins: [formMixin],
    props: {
        intervention: {
            type: Object,
            required: true
        }
    },
    data(){
        return {
            technician: this.intervention.technician,
            signature: null,
            newSignature: {
                date: this.$moment(),
                signatoryId: 'null',
                noSignatory: '1',
                otherSignatory: 'null',
                signature: 'null',
                comment: ''
            },
            contact: null,
            signaturePath: process.env.VUE_APP_API_STORAGE_BASE_URL + '/storage/technicians/' + this.intervention.technician.signature_path,
            noSignatory: false,
            isOtherSignatory: false,
            newSignatory: null,
            contacts: [],
            awaitingRequest: false,
        }
    },
    methods: {
        async getSignatureData() {
            const { data } = await this.$store.dispatch('interventions/getSignatureData', this.intervention.id)
            if (data) {
                this.signature = JSON.parse(data.signature)
                this.newSignature = JSON.parse(data.signature)
                this.contact = data.contact
            }
            if (!this.contact) {
               this.isOtherSignatory = true
            } else {
                this.newSignatory = this.contact
            }
        },
        async getContacts() {
            const { data } = await this.$store.dispatch('interventions/getInterventionContacts', this.intervention.id)
            if(Object.entries(data).length > 0) {
                for (const [key, value] of Object.entries(data)) {
                    this.contacts.push(value)
                }
                this.signatory = data['Contact RDV'].contacts[0]
            } else {
                this.noSignatory = 1
            }
        },
        async updateSignatureData() {
            let signature
            const signatory = this.newSignature.noSignatory === '1' || this.isOtherSignatory ? 'null' : this.newSignatory.id
            const otherSignatory = this.isOtherSignatory ? this.newSignature.otherSignatory : 'null'
            signature = JSON.stringify({
                date: this.signature ? this.signature.date : this.newSignature.date,
                signatoryId: signatory,
                noSignatory: this.newSignature.noSignatory,
                otherSignatory: otherSignatory,
                signature: this.newSignature.signature,
                comment: this.newSignature.comment
            })
            this.awaitingRequest = true
            const { data } = await this.$store.dispatch('interventions/updateSignatureData', {
                interventionId: this.intervention.id,
                report_signature: signature
            })
            this.signature = JSON.parse(data.report.report_signature)
            this.newSignature = JSON.parse(data.report.report_signature)
            this.contact = data.contact
            this.$emit('update-report', data.report)
            this.awaitingRequest = false
            await this.$store.dispatch('alerts/success', 'Informations modifiées')
        }
    },
    mounted() {
        this.getSignatureData()
        this.getContacts()
    },
    watch: {
        'newSignature.noSignatory'(newVal) {
            if(newVal === '1') {
                this.newSignatory = null
            } else if(newVal === '2' && !this.isOtherSignatory) {
                // si un signataire est déjà selectionné, on ne le remplace par le premier de la liste (si il y a des contacts, sinon on le passe a null)
                this.newSignatory = this.newSignatory === null ? (this.contacts.length > 0 ? this.contacts[0].contacts[0] : null) : this.newSignatory
            }
        },
        isOtherSignatory(newVal) {
            if(newVal) {
                this.newSignatory = null
            }
            if (this.newSignature.otherSignatory === 'null') {
                this.newSignature.otherSignatory = ''
            }
        }
    }
}
</script>

<style scoped>

</style>
